<template>
  <div class="loading-icon">
    <i :class="{ [icon]: true, loading: isLoading }" @click="onClick"></i>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    loading(newValue) {
      if (newValue === false) {
        this.clickFlag = false;
      }
    },
  },
  computed: {
    isLoading() {
      return this.loading && this.clickFlag;
    },
  },
  data() {
    return {
      clickFlag: false,
    };
  },
  methods: {
    onClick() {
      this.clickFlag = true;
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #aaa;
  border-radius: 2px;
  cursor: pointer;
  box-sizing: border-box;
}

.loading {
  animation: loading 1500ms ease-in-out infinite;
}

@keyframes loading {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
